<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.order_no" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="推广状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" :value="''"></el-option>
            <el-option label="未入账" :value="10"></el-option>
            <el-option label="已入账" :value="20"></el-option>
            <el-option label="已退款" :value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐人">
          <el-input v-model="searchForm.referee_search" placeholder="昵称/手机号"></el-input>
        </el-form-item>
        <el-form-item label="被邀请人">
          <el-input v-model="searchForm.buyer_search" placeholder="昵称/手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="订单号" width="160"></el-table-column>
          <el-table-column prop="buyer_user_id" label="被邀请人">
            <template slot-scope="scope">
              <div v-if="scope.row.buyer">
                <img class="radius" v-img-url="scope.row.buyer.avatarUrl" width="24" height="24" />
                <span class="pl8">{{ scope.row.buyer.nickName }} (ID: {{ scope.row.buyer.user_id }})</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="referee_user_id" label="推荐人">
            <template slot-scope="scope">
              <span>{{ scope.row.referee_nick || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_amount" label="订单金额"></el-table-column>
          <el-table-column prop="commission_rate" label="佣金比例(%)"></el-table-column>
          <el-table-column prop="commission_amount" label="佣金金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.commission_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 10" type="info" size="mini">未入账</el-tag>
              <el-tag v-else-if="scope.row.status == 20" type="success" size="mini">已入账</el-tag>
              <el-tag v-else-if="scope.row.status == 30" type="warning" size="mini">已退款</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DistributionApi from '@/api/distribution.js'

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 15,
      totalDataNumber: 0,
      curPage: 1,
      searchForm: {
        order_no: '',
        status: '',
        referee_search: '',
        buyer_search: ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const self = this
      const Params = Object.assign({}, self.searchForm, {
        page: self.curPage,
        list_rows: self.pageSize
      })
      self.loading = true
      DistributionApi.promoteOrderList({ Params }, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.list.data || []
          self.totalDataNumber = res.data.list.total || 0
        })
        .catch(() => {
          self.loading = false
        })
    },
    onSubmit() {
      this.curPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.curPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>
.radius {
  border-radius: 50%;
}
.pl8 {
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/promote/index.vue